<script>
    import { createEventDispatcher, tick } from 'svelte';

    /** [{ label }] */
    export let options = [];
    export let selectedIndex = 0;

    const dispatch = createEventDispatcher();

    let buttonRefs = [];
    let pillLeft = 0;
    let pillWidth = 0;

    async function updatePill() {
        await tick();
        const button = buttonRefs[selectedIndex];
        if (!button) return;
        const rect = button.getBoundingClientRect();
        const parentRect = button.parentElement.getBoundingClientRect();
        pillLeft = rect.left - parentRect.left;
        pillWidth = rect.width;
    }

    function select(index) {
        if (index === selectedIndex) return;
        selectedIndex = index;
        dispatch('change', { index, option: options[index] });
    }

    $: selectedIndex, options, updatePill();
</script>

<div class="segmented-toggle">
    <span class="active-pill" style="left: {pillLeft}px; width: {pillWidth}px;"></span>
    {#each options as option, index}
        <button
            type="button"
            class:on={index === selectedIndex}
            bind:this={buttonRefs[index]}
            on:click={() => select(index)}
        >{option.label}</button>
    {/each}
</div>

<style>
    .segmented-toggle {
        display: inline-flex;
        position: relative;
        background: #f1f2f4;
        border-radius: 8px;
        padding: 2px;
    }

    .active-pill {
        position: absolute;
        top: 2px;
        height: calc(100% - 4px);
        background: white;
        border-radius: 6px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
        z-index: 0;
        pointer-events: none;
        transition: left 0.32s cubic-bezier(.4, 1, .4, 1), width 0.32s cubic-bezier(.4, 1, .4, 1);
        will-change: left, width;
    }

    button {
        position: relative;
        z-index: 1;
        border: none;
        background: none;
        border-radius: 6px;
        padding: 6px 14px;
        font-size: 13px;
        color: #6b7280;
        cursor: pointer;
    }

    button.on {
        color: #1f2937;
        font-weight: 600;
    }
</style>
